"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

const ThemeToggle = dynamic(() => import("./ThemeToggle"), { ssr: false });
const ScrollReflection = dynamic(() => import("./ScrollReflection"), { ssr: false });

export default function ClientEnhancements() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    let idleId: number | null = null;

    const enable = () => setEnabled(true);

    if (typeof globalThis !== "undefined" && "requestIdleCallback" in globalThis) {
      idleId = (globalThis as any).requestIdleCallback(enable, { timeout: 1500 });
    } else {
      timeoutId = setTimeout(enable, 1200);
    }

    return () => {
      if (idleId !== null && typeof globalThis !== "undefined" && "cancelIdleCallback" in globalThis) {
        (globalThis as any).cancelIdleCallback(idleId);
      }
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return (
    <>
      <ScrollReflection />
      <ThemeToggle />
    </>
  );
}
